/* eslint-disable */
import {put, takeEvery, select} from "redux-saga/effects";
import SearchEvents from "./SearchEvents";
import VideoApi from "../../common/video/VideoApi";
import {search, searchComplete} from "./SearchActions";
import {SearchResult} from "./SearchResult";
import {createSearchQuery} from "./SearchQuery";
import {AppState} from "../../root/RootReducer";
import {SearchStore} from "./SearchReducer";

function* searchWorker({userId, query, targets, filters}: ReturnType<typeof search>) {
    const searchQuery = createSearchQuery(userId, query, targets, filters);
    const result: SearchResult = yield VideoApi.search(searchQuery);
    console.log("SearchResult:", result)
    yield put(searchComplete(result));
}

function* selectFacetWorker() {
    const {userId, activeQuery, activeFacets, activeTargets}: SearchStore = yield select(({search}: AppState) => search);

    if (activeQuery) {
        const searchQuery = createSearchQuery(userId, activeQuery, activeTargets, activeFacets);
        const result: SearchResult = yield VideoApi.search(searchQuery);

        yield put(searchComplete(result));
   }
}

export default function* VideoSaga() {
    yield takeEvery(SearchEvents.SearchStarted, searchWorker);
    yield takeEvery(SearchEvents.SelectFacet, selectFacetWorker);
    yield takeEvery(SearchEvents.UnselectFacet, selectFacetWorker);
}
